/**
 * sb_toc 노드 등 다국어 name 필드를 가진 객체에서 현재 lang에 맞는 이름을 반환한다.
 *
 * 규칙:
 *   - lang === 'KOR' → node.name
 *   - 그 외(ENG 등) → node.name_em (없으면 node.name_ea, 그래도 없으면 node.name)
 *
 * `lang === 'KOR' ? node.name : node.name_em || node.name_ea` 패턴이
 * 보고서 뷰어 전반(Nav, footer-nav, StoryBoardViewer, SbPrintOption, SearchResultPage 등)에
 * 반복되어 있어 한 곳으로 모았다.
 *
 * @param {{name?: string, name_em?: string, name_ea?: string} | null | undefined} node
 * @param {string} lang
 * @returns {string}
 */
export function getLocalizedName(node, lang) {
  if (!node) return '';
  if (lang === 'KOR') return node.name || '';
  return node.name_em || node.name_ea || node.name || '';
}
